import React, { useMemo } from "react";

interface Props {
  exclusiveUntil: string; // ISO 8601
}

function ExclusiveBadge({ exclusiveUntil }: Props) {
  const info = useMemo(() => {
    if (!exclusiveUntil) return null;

    const until = new Date(exclusiveUntil);
    const now = new Date();
    const diffMs = until.getTime() - now.getTime();
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    const isExpired = diffMs <= 0;

    if (isExpired) {
      return { text: "Завершён", expired: true };
    }

    const daysText =
      diffDays === 1
        ? "1 день"
        : diffDays < 5
          ? `${diffDays} дня`
          : `${diffDays} дней`;
    return { text: `Эксклюзив (ещё ${daysText})`, expired: false };
  }, [exclusiveUntil]);

  if (!info) return null;

  return (
    <span
      style={{
        color: info.expired ? "#999" : "#7EAC2F",
        fontWeight: 600,
        fontSize: 14,
      }}
    >
      {info.text}
    </span>
  );
}

export default ExclusiveBadge;
